/**
 * Shared accessibility helpers for widget UI: a visible keyboard focus ring on
 * every widget control (injected once), regardless of the host page's CSS.
 */

const FOCUS_STYLE_ID = 'rv-focus-styles';

export function ensureFocusStyles(): void {
  if (typeof document === 'undefined' || document.getElementById(FOCUS_STYLE_ID)) return;
  const style = document.createElement('style');
  style.id = FOCUS_STYLE_ID;
  style.textContent = ` .rv-toolbar button:focus-visible, .rv-toolbar select:focus-visible, .rv-toolbar a:focus-visible, .rv-tb-dropdown button:focus-visible, .rv-tb-dropdown input:focus-visible, .rv-tb-dropdown select:focus-visible, .rv-player button:focus-visible, .rv-player select:focus-visible, .rv-player input:focus-visible, .rv-context-menu button:focus-visible, .rv-toggle-btn:focus-visible, .rv-lms-notice button:focus-visible { outline: 3px solid #2563eb !important; outline-offset: 2px !important; box-shadow: 0 0 0 5px rgba(255,255,255,0.9) !important; } `;
  (document.head || document.documentElement).appendChild(style);
}
